import { render, staticRenderFns } from "./apiget_apijcdome.vue?vue&type=template&id=2fa8e466"
import script from "./apiget_apijcdome.vue?vue&type=script&lang=js"
export * from "./apiget_apijcdome.vue?vue&type=script&lang=js"
import style0 from "./apiget_apijcdome.vue?vue&type=style&index=0&id=2fa8e466&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports